import { addSpaceNumber } from 'utils/addSpaceNumber';

interface GetOrderAmountErrorMessageParams {
  balance: string | number;
  insufficientBalanceError: boolean;
  amountError?: string | null;
  platformLimitError: boolean;
  min: number;
  max: number;
  isUnitBased: boolean;
}

export const getOrderAmountErrorMessage = ({
  balance,
  insufficientBalanceError,
  amountError,
  platformLimitError,
  min,
  max,
  isUnitBased,
}: GetOrderAmountErrorMessageParams): string | null => {
  if (!balance && !isUnitBased) {
    return 'Средств на балансе недостаточно для создания заказа';
  }

  if (insufficientBalanceError && !isUnitBased) {
    return 'Недостаточно средств на балансе';
  }

  if (amountError) {
    return amountError;
  }

  if (platformLimitError) {
    return `Допустимая сумма заказа от ${addSpaceNumber(min)} до ${addSpaceNumber(
      max,
    )} ₽`;
  }

  return null;
};
